import React from 'react';
import { string, number } from 'prop-types';
import moment from 'moment';
import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import analytics from '../../../../modules/analytics';
import { AngledTag } from '../../../ui/Tag';

const NEW_BADGE = {
  label: 'New',
  borderColor: colors.spark,
  color: '#e2ffff', // put this in themeColors if productized
};
const THRESHOLD_BADGES = [{
  threshold: 10000,
  color: '#fffcf1', // put this in themeColors if productized
  borderColor: colors.sunshine,
  label: '10K+ Booked',
}, {
  threshold: 5000,
  color: '#d6efff', // put this in themeColors if productized
  borderColor: colors.slate,
  label: '5K+ Booked',
}, {
  threshold: 1000,
  color: '#fff6f4',
  borderColor: colors.petal, // put this in themeColors if productized
  label: '1K+ Booked',
}];

const getBadge = ({ totalAppointments, proJoinDate }) => {
  // Ensure that the highest badge threshold met is applied even if
  // the order of badge definitions changes
  const thresholdBadge = THRESHOLD_BADGES.sort((a, b) => b.threshold - a.threshold)
    .find(({ threshold }) => totalAppointments >= threshold);

  if (!thresholdBadge && moment(proJoinDate).isAfter(moment().startOf('day').subtract(6, 'months'))) {
    return NEW_BADGE;
  }

  return thresholdBadge;
};

/**
 * Determines the badge to display for a pro based on when the pro joined
 * and how many total appointments they have booked.
 * @param {Object} props
 */
export const AppointmentBadgeBase = ({
  totalAppointments,
  proJoinDate,
}) => {
  const badge = getBadge({
    totalAppointments,
    proJoinDate,
  });
  const {
    label,
    threshold,
    ...restBadge
  } = badge || {};
  React.useEffect(() => {
    if (badge) {
      analytics.track('client_proprofile_bookingbadge_seen', {
        appointments: totalAppointments,
        joinDate: proJoinDate,
        badge: badge.label,
      });
    }
  }, [totalAppointments, proJoinDate]);
  return badge ? (
    <Inline testID="appointmentBadge">
      <AngledTag
        {...restBadge}
      >
        {label}
      </AngledTag>
    </Inline>
  ) : null;
};

export const propTypes = {
  /**
   * The total number of appointments the pro has booked
   */
  totalAppointments: number.isRequired,
  /**
   * The date the pro joined StyleSeat
   */
  proJoinDate: string.isRequired,
};

AppointmentBadgeBase.propTypes = propTypes;

export default AppointmentBadgeBase;
